import { motion } from 'framer-motion';

interface Category {
  category: string;
  percentage: number;
  amount: number;
}

interface SpendingCategoriesBoxProps {
  categories: Category[];
}

export const SpendingCategoriesBox = ({ categories }: SpendingCategoriesBoxProps) => {
  return (
    <div className="bg-white rounded-xl p-4 relative border-2 border-[#221A51] shadow-[4px_4px_0px_0px_#221A51]">
      <div className="text-[#221A51]/60 text-sm mb-3">Top Categories</div>
      <div className="space-y-3">
        {categories.map((category, index) => (
          <div key={category.category} className="space-y-1">
            <div className="flex justify-between items-center">
              <div className="min-w-0 flex-1 mr-4">
                <div className="text-sm text-[#221A51] truncate whitespace-nowrap">
                  {category.category}
                </div>
              </div>
              <div className="text-base font-bold text-[#221A51] flex-shrink-0">
                {Math.round(category.percentage)}%
              </div>
            </div>

            {/* Progress bar */}
            <div className="h-1.5 bg-[#8364FF]/10 rounded-full overflow-hidden">
              <motion.div
                initial={{ width: 0 }}
                animate={{ width: `${category.percentage}%` }}
                transition={{ delay: 0.2 + index * 0.1, duration: 1 }}
                className="h-full bg-[#9B86EA] rounded-full"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
